import { render } from "./PlayerTimer.vue?vue&type=template&id=05163136&ts=true"
import script from "./PlayerTimer.vue?vue&type=script&lang=ts"
export * from "./PlayerTimer.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__